import React, { useEffect, useState } from 'react';
import { hasPermission } from '../services/authService';
import { useNavigate } from 'react-router-dom';
import { listServices, addService, updateService, deleteService } from '../services/serviceService';
import { useCurrency } from '../context/CurrencyContext';
import './Admin.css';

export default function ServicesAdmin() {
  const navigate = useNavigate();
  const [services, setServices] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const { formatPrice } = useCurrency();
  const [form, setForm] = useState({ id: null, name: '', description: '', price: '' });

  useEffect(() => {
    if (!hasPermission('admin.services')) navigate('/login');
    (async () => { setServices(await listServices()); })();
  }, [navigate]);

  const handleSave = async (e) => {
    e.preventDefault();
    const payload = { name: form.name, description: form.description, price: Number(form.price || 0) };
    if (form.id) {
      await updateService(form.id, payload);
      setServices(await listServices());
    } else {
      await addService(payload);
      setServices(await listServices());
    }
    setShowForm(false);
    setForm({ id: null, name: '', description: '', price: '' });
  };

  const handleEdit = (s) => { setForm({ id: s.id, name: s.name || '', description: s.description || '', price: s.price || 0 }); setShowForm(true); };
  const handleDelete = async (id) => { if (!window.confirm('Delete this service?')) return; await deleteService(id); setServices(await listServices()); };

  return (
    <div>


      {showForm && (
        <div style={{ position: 'fixed', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.5)', zIndex: 100 }}>
          <div className="admin-card" style={{ width: 500, margin: 0 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
              <h3 className="admin-title" style={{ fontSize: 18, margin: 0 }}>{form.id ? 'Edit Service' : 'Add Service'}</h3>
              <button onClick={() => setShowForm(false)} style={{ background: 'none', border: 'none', fontSize: 24, cursor: 'pointer', color: '#64748b' }}>&times;</button>
            </div>
            <form onSubmit={handleSave}>
              <div className="admin-form-group">
                <label className="admin-label">Service Name</label>
                <input className="admin-input" required placeholder="e.g. Installation" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
              </div>
              <div className="admin-form-group">
                <label className="admin-label">Description</label>
                <textarea className="admin-textarea" placeholder="Description of service..." value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} rows={4} />
              </div>
              <div className="admin-form-group">
                <label className="admin-label">Price</label>
                <input className="admin-input" type="number" step="0.01" placeholder="0.00" value={form.price} onChange={(e) => setForm({ ...form, price: e.target.value })} />
              </div>
              <div className="admin-actions">
                <button type="button" className="admin-btn admin-btn-secondary" onClick={() => { setShowForm(false); setForm({ id: null, name: '', description: '', price: '' }); }}>Cancel</button>
                <button type="submit" className="admin-btn admin-btn-primary">Save Service</button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div className="admin-card">
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
          <button className="admin-btn admin-btn-primary" onClick={() => { setShowForm(true); setForm({ id: null, name: '', description: '', price: '' }); }} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" /></svg>
            Add Service
          </button>
        </div>
        {services.length === 0 ? <div className="admin-text">No services found.</div> : (
          <div className="admin-table-container">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Price</th>
                  <th style={{ textAlign: 'right' }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {services.map(s => (
                  <tr key={s.id}>
                    <td style={{ fontWeight: 600 }}>{s.name}</td>
                    <td style={{ color: '#64748b' }}>{s.description}</td>
                    <td>{formatPrice(s.price)}</td>
                    <td style={{ textAlign: 'right' }}>
                      <button className="admin-btn admin-btn-secondary admin-btn-sm" onClick={() => handleEdit(s)} style={{ marginRight: 8 }}>Edit</button>
                      <button className="admin-btn admin-btn-danger admin-btn-sm" onClick={() => handleDelete(s.id)}>Delete</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
